import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import googleCalendarPlugin from '@fullcalendar/google-calendar';

import './calendar.css';

const Calendar = props => (
    <div className="container">
        <FullCalendar
            locale="it"
            headerToolbar={{ left: 'title', center: '', right: 'today prev,next' }}
            buttonText={{
                today: 'Vai a oggi',
                timeGridDay: 'Giorno',
                timeGridWeek: 'Settimana',
                dayGridMonth: 'Mese'
            }}
            footerToolbar={{center: 'timeGridDay timeGridWeek dayGridMonth'}}
            initialView="timeGridDay"
            slotMinTime="09:00:00"
            themeSystem="standard"
            allDaySlot={false}
            plugins={[dayGridPlugin, timeGridPlugin, googleCalendarPlugin]}
            events={{
                googleCalendarId: props.calendarId
            }}
            googleCalendarApiKey={props.apiKey}
            />
    </div>

)

export default Calendar;
